export default "__VITE_ASSET__CONoWANx__"